import axios from "axios";
import { tmsApi } from "../api";

export const signinUser = async (body) => {
  const config = {
    headers: {
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios.post(tmsApi + "auth/login", body, config).then((resp) => {
      console.log(resp, "response");
      return resp;
    });
  } catch (error) {
    return error
  }
};

export const postForgotPassword = async (body) => {
  const config = {
    headers: {
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios.post(tmsApi + "auth/forgotpassword", body,config).then((resp) => {
      console.log(resp, "response");
      return resp;
    });
  } catch (error) {
    console.log("error", error);
  }
};

export const verifyOtp = async (body) => {
  const config = {
    headers: {
      "Access-Control-Allow-Origin": "*"
    },
  };
  try {
    return axios.post(tmsApi + "auth/verify/otp", body,config).then((resp) => {
      console.log(resp, "response");
      return resp;
    });
  } catch (error) {
    console.log("error", error);
  }
};

export const postResetPassword = async (body) => {
    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*"
      },
    };
    try {
      return axios.post(tmsApi + `auth/resetpassword/${body.userKey}/${body.newPassword}`,config).then((resp) => {
        console.log(resp, "response");
        return resp;
      });
    } catch (error) {
      console.log("error", error);
    }
  };

  
export const changePassword = async (body) => {
    const config = {
      headers: {
        token: `${localStorage.getItem('token')}`,
        "Access-Control-Allow-Origin": "*",
      },
    };
    try {
      return axios.post(tmsApi + "auth/changepassword",body, config).then((resp) => {
        console.log(resp, "response");
        return resp;
      });
    } catch (error) {
      console.log("error", error);
      // return error;
     
    }
  };

  export const getUserByKey = async (obj) => {
    const config = {
      headers: {
        token: `${localStorage.getItem('token')}`,
        "Access-Control-Allow-Origin": "*",
      },
    };
    try {
      return axios.get(tmsApi + `auth/user/${obj.userKey}`, config).then((resp) => {
        console.log(resp, "response");
        return resp;
      });
    } catch (error) {
      console.log("error", error);
      // return error;
     
    }
  };

export const signOutUser = ()=>{
    const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          token:localStorage.getItem('token')
        },
      };
      try {
        return axios.post(tmsApi + "auth/logout", config).then((resp) => {
          console.log(resp, "response");
          return resp;
        });
      } catch (error) {
        console.log("error", error);
      }
}


export const checkTokenExpiry = ()=>{
  const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        token:localStorage.getItem('token')
      },
    };
    try {
      return axios.get(tmsApi + "auth/token/validate", config).then((resp) => {
        console.log(resp, "response");
        return resp;
      });
    } catch (error) {
      return error;
    }
}



